"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditViewField = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const spinner_1 = require("../../components/spinner/spinner");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const classnames_1 = require("../../util/classnames");
const collection_view_style_1 = require("./collection.view.style");
const field_view_builder_1 = require("./fields/field.view.builder");
class CollectionEditViewField {
    static view(ctrl, collection, schema) {
        const id = `i-${collection.instanceId}-${schema.id}`;
        const field = collection.getField(schema.id);
        const fieldView = field_view_builder_1.CollectionFieldViewBuilder.getFieldView(field);
        const hasValue = field.hasValue();
        const hasDetail = hasValue && fieldView.hasDetail && fieldView.hasDetail(field);
        const showDetail = ctrl.isFieldDetailShown.get(id);
        const hasUpload = fieldView.canUpload && fieldView.canUpload(field) && ctrl.isEditing;
        let imageTool = null;
        if (fieldView.canUpload && fieldView.canUpload(field)) {
            imageTool = field;
        }
        const hasGeocoding = fieldView.canGeocoding && fieldView.canGeocoding(field);
        const hasFile = fieldView.hasFile && fieldView.hasFile(field);
        let fileToolField = null;
        if (hasFile) {
            fileToolField = field;
        }
        const isLoading = (core_shared_1.CollectionModelFieldFileTool.isFileToolField(field) || core_shared_1.CollectionModelFieldImage.isImageField(field)) &&
            ctrl.isUploading &&
            ctrl.fieldsInLoadingState.indexOf(field.id) > -1;
        let hasClear = false;
        let fieldValue;
        const userIsAdmin = services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)) ||
            services_1.Services.UserProfile.isDepartmentDataAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId));
        const userCanEditField = userIsAdmin || !field.schema.adminOnly;
        if (ctrl.isEditing && userCanEditField) {
            fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value }, fieldView.viewEdit(field, ctrl));
            hasClear = fieldView.hasClear == null ? hasValue : fieldView.hasClear(field);
            // if the field is CollectionModelFieldVector and the provider is collection, but it's not exists anymore
            // the field text is 'Unknown' but we don't have value, so we don't show the clearButton
            // we fix that here
            if ((core_shared_1.CollectionModelFieldVector.isVectorField(field) || core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) &&
                typeof fieldView.viewEdit(field, ctrl) !== 'string' &&
                fieldView.viewEdit(field, ctrl).text === (0, i18n_1.Translate)(i18n_1.T.UNKNOWN)) {
                hasClear = true;
            }
        }
        else if (hasValue) {
            const inlineText = fieldView.viewInline(field, ctrl);
            if (typeof inlineText === 'string') {
                const children = [inlineText];
                if (
                // We have the correct token
                services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) &&
                    // And the field is one of the two list types which can have colors
                    (core_shared_1.CollectionModelFieldSelectList.isSelectListField(field) ||
                        core_shared_1.CollectionModelFieldNestedList.isNestedListField(field)) &&
                    // And this instance is the one that is marked as the color field
                    field.collection.schema.metadata.mapColorFieldId === field.schema.id) {
                    if (field.color) {
                        children.push((0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.colorIndicator, style: { backgroundColor: field.color } }));
                    }
                }
                fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value, title: inlineText }, children);
            }
            else {
                fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value }, inlineText);
            }
        }
        const title = schema.displayName;
        return (0, mithril_1.m)('div', {
            className: (0, classnames_1.classNames)(collection_view_style_1.CSS.field.container, {
                [collection_view_style_1.CSS.isEmpty]: !hasValue,
            }),
            id,
            onclick: (e) => {
                const handleClickAway = () => {
                    page_state_1.CurrentState.setInspectedFieldId(null);
                    services_1.Services.FocusAway.drop(e.target, handleClickAway);
                };
                page_state_1.CurrentState.setInspectedFieldId(field.id);
                services_1.Services.FocusAway.from(e.target, handleClickAway);
            },
        }, [
            (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.summary }, [
                (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.title, title }, title),
                fieldValue,
                isLoading ? CollectionEditViewField.viewLoadingSpinner(ctrl, field) : null,
                hasUpload ? CollectionEditViewField.viewFieldUploadButton(ctrl, imageTool) : null,
                hasFile ? CollectionEditViewField.viewFileDownloadButton(ctrl, fileToolField) : null,
                hasClear && hasFile ? CollectionEditViewField.viewFieldClearModalButton(ctrl, field) : null,
                hasClear && !hasFile ? CollectionEditViewField.viewFieldClearButton(ctrl, field) : null,
                hasDetail ? CollectionEditViewField.viewFieldDetailButton(ctrl, id) : null,
                hasGeocoding ? CollectionEditViewField.viewFieldGeocodingButton(ctrl, field) : null,
                hasGeocoding && !ctrl.clearErrorDisabled(field)
                    ? CollectionEditViewField.viewFieldClearErrorButton(ctrl, field)
                    : null,
            ]),
            showDetail ? (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.detail }, fieldView.viewDetail(field)) : null,
        ]);
    }
    static viewFieldClearErrorButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: () => ctrl.clearError(field),
            disabled: ctrl.clearErrorDisabled(field),
        });
    }
    static viewFieldClearButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: () => ctrl.clearField(field),
        });
    }
    static viewFieldClearModalButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: () => ctrl.clearModalField(field),
        });
    }
    static viewFieldDetailButton(ctrl, fieldInstanceId) {
        let icon = icons_1.MaterialIcon.INFO_FILLED;
        if (ctrl.isFieldDetailShown.get(fieldInstanceId)) {
            icon = icons_1.MaterialIcon.INFO;
        }
        return image_button_1.ImageButton.view(icon, {
            onclick: () => ctrl.toggleFieldDetail(fieldInstanceId),
        });
    }
    static viewFieldGeocodingButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.LOCATION, {
            onclick: () => ctrl.fillAddress(field),
            disabled: ctrl.fillAddressDisabled(field),
            title: ctrl.geocodingButtonTitle(field),
        });
    }
    static viewLoadingSpinner(ctrl, field) {
        return spinner_1.Spinner.view();
    }
    static viewFileDownloadButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
            onclick: (e) => ctrl.fileDownload(field),
        });
    }
    static viewFieldUploadButton(ctrl, field) {
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.isImageUpload }, (0, mithril_1.m)('form', [
            (0, mithril_1.m)('input', {
                className: 'c--Image--fileupload',
                style: 'display:none;',
                type: 'file',
                accept: 'image/jpeg',
                id: field.id,
                onchange: (e) => ctrl.onImage(e, field),
            }, ''),
            (0, mithril_1.m)('div', {
                id: `image-upload-${field.id}`,
                style: 'border:none',
                className: collection_view_style_1.CSS.container,
                onclick: (e) => ctrl.openImageDialog(e, field),
            }, image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_UPLOAD)),
        ]));
    }
}
exports.CollectionEditViewField = CollectionEditViewField;
//# sourceMappingURL=collection.view.field.js.map